const ENDPOINT_TEACHER_DISCIPLINE = '/secure/me/teacher-discipline'
const ENDPOINT_UPDATE_TEACHER_DISCIPLINE =
  '/secure/me/teacher-discipline/:disciplineId'
const ENDPOINT_TEACHER_DISCIPLINE_DIPLOMA =
  '/secure/me/teacher-discipline/:disciplineId/diploma'
const ENDPOINT_TEACHER_DISCIPLINE_DIPLOMA_DELETE =
  '/secure/me/teacher-discipline/:disciplineId/diploma/:diplomaId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async createTeacherDiscipline({ commit, rootState }, payload) {
    try {
      //      console.log(JSON.stringify(payload))
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        `${ENDPOINT_TEACHER_DISCIPLINE}`,
        payload
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },

  async updateTeacherDiscipline({ commit, rootState }, payload) {
    try {
      //      console.log(JSON.stringify(payload))
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.put(
        ENDPOINT_UPDATE_TEACHER_DISCIPLINE.replace(':disciplineId', payload.id),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },

  async deleteTeacherDiscipline({ commit, rootState }, payload) {
    try {
      //      console.log(JSON.stringify(payload))
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_UPDATE_TEACHER_DISCIPLINE.replace(':disciplineId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },

  async addDiplomaTeacherDiscipline({ commit, rootState }, payload) {
    try {
      //      console.log(JSON.stringify(payload))
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_TEACHER_DISCIPLINE_DIPLOMA.replace(
          ':disciplineId',
          payload.id
        ),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },

  async deleteDiplomaTeacherDiscipline({ commit, rootState }, payload) {
    try {
      //      console.log(JSON.stringify(payload))
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_TEACHER_DISCIPLINE_DIPLOMA_DELETE.replace(
          ':disciplineId',
          payload.disciplineId
        ).replace(':diplomaId', payload.diplomaId)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
